import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 surface-100 border-round-xl" }
const _hoisted_2 = { class: "flex align-items-center>" }
const _hoisted_3 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = {
  key: 1,
  class: "py-8 text-center text-color-secondary"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useReviewReportStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewReportExitedStudents',
  setup(__props) {

const { exitedStudents } = storeToRefs(useReviewReportStore());

const hasTotals = computed(() => Object.keys(exitedStudents.value.data).length);

const totals = computed(() => {
  return exitedStudents.value.data.map((item) => {
    return {
      total: new Intl.NumberFormat().format(item.total),
      reason: item.archived_reason.reason,
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "flex-1 text-base text-color-secondary mb-2" }, "Exited Students", -1)),
      _withDirectives(_createVNode(_component_Icon, {
        name: "info",
        class: "text-gray-400 text-base cursor-pointer"
      }, null, 512), [
        [
          _directive_tooltip,
          'Total Students that have been archived within the system.',
          void 0,
          { left: true }
        ]
      ])
    ]),
    (hasTotals.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals.value, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "p-2 border-round bg-white"
            }, [
              _createElementVNode("div", {
                class: "text-color-gray text-sm",
                textContent: _toDisplayString(item.reason)
              }, null, 8, _hoisted_4),
              (_unref(exitedStudents).loading)
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    height: "1rem",
                    class: "mt-1"
                  }))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "text-color-gray text-lg font-bold",
                    textContent: _toDisplayString(item.total)
                  }, null, 8, _hoisted_5))
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, [
          (_unref(exitedStudents).loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Searching for Exited Students"))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "No data for Exited Students"))
        ]))
  ]))
}
}

})